/*
 * Service for reports resources
 */

app.service("_$report", ["$http", "$mdDialog", function($http, $mdDialog) {

    //saved states
    var states = null;
    //saved types
    var types = null;

    var categories = null;

    //return promise and inside statuses dictionary
    this.getStates = function() {

        //singleton
        if (states != null)
            return states;
        else
            return $http.get("reportstate").then(function(resp) {
                states = resp.data;
                return resp.data;
            });

    };


    //return promise and inside types dictionary
    this.getTypes = function() {

        if (types != null)
            return types;
        else
            return $http.get("reporttype").then(function(resp) {
                types = resp.data;
                return resp.data;
            });

    };

    //return promise and inside single report object from server
    this.getSingle = function(id) {

        return $http.get("report/" + id).then(function(resp) {
            console.log(resp.data);
            return resp.data;
        });

    };

    this.getCategories = function(){
      if (categories != null)
          return categories;
      else
          return $http.get("reportcategory").then(function(resp) {
              categories = resp.data;
              return resp.data;
          });
    }

    //return promise and end types of report
    this.getEnds = function(id) {

        return $http.get("reportend").then(function(resp) {
            return resp.data;
        });

    };

    this.getMap = function() {
        return $http.get("/report/map").then(function(resp) {
            return resp.data;
        });
    };


    //do the save action
    this.save = function(data, id) {

        return $http.put("report/" + id, data);

    };

    this.activate = function(id) {

        return $http.put("report/activate/" + id);

    };

    this.deactivate = function(id) {

        return $http.put("report/deactivate/" + id);
    };

    this.adopt = function(id) {

        return $http.put("report/adopt/" + id);
    };

    this.resume = function(id) {

        return $http.put("report/resume/" + id);
    };

    this.getConnectedReports = function(id) {

        return $http.get("report/connected/" + id);
    };


    //gets reports to which current can be connected as child
    this.getPossibleToConnectReports = function(id) {

        return $http.get("report/possibleconnect/" + id);

    };


    /**
     * shows modal with connect possibility
     */
    this.showConnectDialog = function(list) {

        var connectToId = null;

        return $mdDialog.show({
            templateUrl: '/assets/js/angular/message/views/modal/report/connect.html',
            controller: function(scope) {

                //set list to select
                scope.list = list;

                scope.change = function(val) {

                    connectToId = val;

                };


                scope.commit = function() {

                    $mdDialog.hide();
                };

                scope.cancel = function() {

                    $mdDialog.cancel();
                };

            }
        }).then(function() {
            return connectToId;
        });

    };

    //unconnect report from other one
    this.unConnect = function(id) {

        return $http.put("report/unconnect/" + id);

    };


    //connect two reports
    function connect(parentId, childrensIds) {

        return $http.post("report/connectmany", {
            rootid: parentId,
            ids: childrensIds
        });

    };


    this.connect = connect;

    this.sticky = {


        adopt: function(ids) {

            return $http.post("report/adoptmany", ids);
        },
        block: function(ids) {

            return $http.post("report/blockmany", ids);
        },
        unblock: function(ids) {

            return $http.post("report/unblockmany", ids);
        },
        connect: function(rootid, ids) {

            return connect(rootid, ids);
        }

    };

    this.getForwardState = function() {
        return $http.get("/reportstate/getforward");
    };

    this.removeImage = function(id) {
        return $http.post("/report/removeimage", {
            "id": id
        });
    };

    this.rollbackState = function(id) {
        return $http.post("/report/rollbackstate", {
            "id": id
        });
    };

    this.updateComment = function(comment) {
        return $http.post("/report/updatecomment", {
            "id": comment.id,
            "content": comment.content
        });
    };

}]);
